import { useQuery } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';

export const useGetLegalClientDistributions = () => {
  const {
    data: legalClientDistributions,
    isLoading: isLoadingLegalClientDistributions,
  } = useQuery<{ [key: string]: number }[]>({
    queryKey: ['dashboard/legalclient/distribution'],
    queryFn: () =>
      customFetcher({ endpoint: '/dashboard/legalclient/distribution' }),
  });

  return { legalClientDistributions, isLoadingLegalClientDistributions };
};

export const useGetLoginLastWeek = () => {
  const { data: loginsLastWeek, isLoading: isLoadingLoginLastWeek } = useQuery<{
    Total: number;
    LoggedUser: number;
  }>({
    queryKey: ['dashboard/legalclient/login_last_week'],
    queryFn: () =>
      customFetcher({ endpoint: '/dashboard/legalclient/login_last_week' }),
  });

  return { loginsLastWeek, isLoadingLoginLastWeek };
};

export const useGetLoginDistribution = () => {
  const { data: loginDistributions, isLoading: isLoadingLoginDistributions } =
    useQuery<{
      Total: number;
      ActivUser: number;
      InactivUser: number;
      BlockedUser: number;
    }>({
      queryKey: ['dashboard/legalclient/login_distribution'],
      queryFn: () =>
        customFetcher({
          endpoint: '/dashboard/legalclient/login_distribution',
        }),
    });

  return { loginDistributions, isLoadingLoginDistributions };
};

export const useGetDocumentsRequested = () => {
  const { data: documentRequested, isLoading: isLoadingDocumentRequested } =
    useQuery<{ [key: string]: number }>({
      queryKey: ['dashboard/documents/requested'],
      queryFn: () =>
        customFetcher({
          endpoint: '/dashboard/documents/requested',
        }),
    });

  return { documentRequested, isLoadingDocumentRequested };
};

export const useGetDocumentsDownloaded = () => {
  const { data: documentDownloaded, isLoading: isLoadingDocumentDownloaded } =
    useQuery<{ [key: string]: number }>({
      queryKey: ['dashboard/documents/downloaded'],
      queryFn: () =>
        customFetcher({
          endpoint: '/dashboard/documents/downloaded',
        }),
    });

  return { documentDownloaded, isLoadingDocumentDownloaded };
};

export const useGetDocumentsUploaded = () => {
  const { data: documentUploaded, isLoading: isLoadingDocumentUploaded } =
    useQuery<{ [key: string]: number }>({
      queryKey: ['dashboard/documents/uploaded'],
      queryFn: () =>
        customFetcher({
          endpoint: '/dashboard/documents/uploaded',
        }),
    });

  return { documentUploaded, isLoadingDocumentUploaded };
};

export const useGetLoginsBrowser = () => {
  const { data: browserDistribution, isLoading: isLoadingBrowserDistribution } =
    useQuery<{ [key: string]: number }>({
      queryKey: ['dashboard/logins/browser'],
      queryFn: () =>
        customFetcher({
          endpoint: '/dashboard/logins/browser',
        }),
    });

  return { browserDistribution, isLoadingBrowserDistribution };
};

export const useGetLoginsOS = () => {
  const { data: osDistribution, isLoading: isLoadingOSDistribution } =
    useQuery<{ [key: string]: number }>({
      queryKey: ['dashboard/logins/os'],
      queryFn: () =>
        customFetcher({
          endpoint: '/dashboard/logins/os',
        }),
    });

  return { osDistribution, isLoadingOSDistribution };
};
